'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".SwatchesList-module_wrapper__9Yy2A{display:flex;flex-wrap:wrap;gap:.5rem;width:100%}.SwatchesList-module_label__PFkDs{font-weight:700}";
var styles = {"wrapper":"SwatchesList-module_wrapper__9Yy2A","label":"SwatchesList-module_label__PFkDs"};
styleInject["default"](css_248z, '7e71b66c-9864-4d61-8874-ff8ff09f9aae');

exports["default"] = styles;
